"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPlay', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4.51523 2.12536C4.83319 1.94913 5.22173 1.95933 5.53 2.152L13.53 7.152C13.8224 7.33474 14 7.65521 14 8C14 8.34479 13.8224 8.66526 13.53 8.848L5.53 13.848C5.22173 14.0407 4.83319 14.0509 4.51523 13.8746C4.19728 13.6984 4 13.3635 4 13V3C4 2.63648 4.19728 2.30158 4.51523 2.12536ZM6 4.80425V11.1958L11.1132 8L6 4.80425Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M3.50194 2.13286C3.81243 1.95452 4.19458 1.9558 4.50387 2.13622L16.5039 9.13622C16.8111 9.31543 17 9.64433 17 10C17 10.3557 16.8111 10.6846 16.5039 10.8638L4.50387 17.8638C4.19458 18.0442 3.81243 18.0455 3.50194 17.8671C3.19145 17.6888 3 17.3581 3 17V3C3 2.64193 3.19145 2.3112 3.50194 2.13286ZM5 4.74104V15.259L14.0154 10L5 4.74104Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M4.50958 3.12851C4.82437 2.95137 5.21022 2.95775 5.51898 3.14521L19.519 11.6452C19.8259 11.8315 20.0093 12.168 19.9996 12.5269C19.99 12.8858 19.7887 13.212 19.4722 13.3815L5.47222 20.8815C5.1623 21.0475 4.78795 21.0386 4.4863 20.858C4.18464 20.6774 4 20.3516 4 20V4C4 3.63879 4.19479 3.30566 4.50958 3.12851ZM6 5.77702V18.3298L16.9837 12.4457L6 5.77702Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M5.75866 3.196C6.22764 2.92938 6.80367 2.93513 7.26723 3.21106L28.2672 15.7111C28.7216 15.9815 29 16.4712 29 17C29 17.5288 28.7216 18.0185 28.2672 18.2889L7.26723 30.7889C6.80367 31.0649 6.22764 31.0706 5.75866 30.804C5.28969 30.5374 5 30.0395 5 29.5V4.5C5 3.96053 5.28969 3.46262 5.75866 3.196ZM8 7.13848V26.8615L24.5674 17L8 7.13848Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;